<div class="vcard-for-order" [ngClass]="{'-no-left': !showOrderId || !orderId, '-side-paddings': sidePaddings}">
    <div class="vcard-for-order__inner">

        <div class="vcard-for-order__col -left" *ngIf="orderId && showOrderId">
            <shared-order-id [orderId]="orderId" class="vcard-for-order__id"></shared-order-id>
        </div>

        <div class="vcard-for-order__col -right">
            <shared-header *ngIf="preTitle" class="vcard-for-order__hd" [brandAccent]="true" [type]="preTitleType"
                [marginTop]="preTitleMarginTop" [marginBottom]="preTitleMarginBottom">
                {{preTitle}}</shared-header>

            <shared-header class="vcard-for-order__hd" [type]="titleType" [marginTop]="titleMarginTop"
                [marginBottom]="titleMarginBottom">
                <ng-content></ng-content>
            </shared-header>

            <div class="vcard-for-order__desc" *ngIf="description">
                {{description}}
            </div>
        </div>

    </div>
</div>
